<style lang="stylus">
.introBgImg {
  background: url('../assets/icons/asu_girl_bg.png') center / cover no-repeat;
}
</style>
<template>
  <div>
    <!-- <login-header-component></login-header-component> -->
    <div class="introBgImg">
      <v-container class="container">
        <v-row row>
          <div
            style="
              color: black;
              background-color: #f1e9e6;
              padding: 0px 45px 5px 20px;
              width: max-content;
              margin: 16rem 0 8rem 0;
            "
          >
            <v-col cols="12">
              <span
                style="position: absolute; font-size: 70px; font-weight: 500; color: #d0d0d0; margin-top: 1rem"
                v-if="shouldDisplay"
                ><strong>{{ statusCode }}</strong></span
              >
              <div style="font-weight: 600; padding: 0rem 0px 0px 1.7rem; position: relative">
                {{ showMsg }}
              </div>
              <br />
              <p style="margin-left: 24px; font-size: 18px" v-html="displayMsg" />
              <p style="padding-top: 5px; margin-left: 24px; font-size: 18px" v-if="shouldDisplay">
                Return to our
                <strong
                  ><b
                    ><span
                      style="border-bottom: 1px solid black; cursor: pointer"
                      @click="navigateTo(ulcPartnerFlag ? 'http://ulc.asu.edu/' : 'http://ea.asu.edu/')"
                      >home page</span
                    ></b
                  >
                </strong>
                or
                <strong
                  ><b
                    ><span
                      style="border-bottom: 1px solid black; cursor: pointer"
                      @click="navigateTo('mailto:earnedadmission@asu.edu')"
                      >contact support</span
                    ></b
                  ></strong
                >.
              </p>
            </v-col>
          </div>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

import { AjaxLoader } from '../mixins/ajaxLoader';
import { Helper } from '../mixins/helpers';

export default defineComponent({
  name: 'NotFoundError',
  data() {
    return {
      shouldDisplay: true,
      showMsg: '',
      statusCode: ''
    };
  },

  mixins: [Helper, AjaxLoader],

  props: {
    response: {
      type: Object
    },
    isEligibleForSignUp: {
      type: Boolean
    },
    referenceId: {
      type: String
    }
  },

  methods: {
    navigateTo(url) {
      window.open(url, '_blank');
    }
  },

  computed: {
    ulcPartnerFlag() {
      return Helper.methods.isUlcPartner();
    }
  },

  created() {
    if (this.$session.exists('fromCallBack') || !this.isEligibleForSignUp) {
      this.shouldDisplay = false;
      this.displayMsg = `<b>Oops! Something went wrong. Please try again later.</b><br/><br/>If this problem persists, you may <a href=${
        this.ulcPartnerFlag ? 'https://ulc.asu.edu/contact-us/' : 'https://ea.asu.edu/contact/'
      } target="_blank">contact our support team</a>.`;
      if (this.referenceId) {
        this.displayMsg =
          this.displayMsg + '<br/><span v-if="referenceId"> Error Code: ' + this.referenceId + '</span>';
      }
      this.$session.remove('fromCallBack');
    } else {
      this.statusCode = this.response ? this.response.status : '404';
      this.showMsg = this.response ? this.response.statusText : 'NOT FOUND';
      this.displayMsg = 'We can’t seem to find the page you’re looking for.';
    }
  }
});
</script>
